import { Button, HStack } from "@chakra-ui/react";
import CDS from "design-system";
import { Task } from "features/Resources/Task/models";
import { taskActionLabel } from "features/Resources/Task/helpers";

interface TaskActionButtonsProps {
  task: Task;
  onMarkComplete: () => void;
  onSkip: () => void;
  onActionClick: () => void;
}

export default function TaskActionButtons({ task, onMarkComplete, onSkip, onActionClick }: TaskActionButtonsProps) {
  const isActionable = !["completed", "skipped"].includes(task.status);
  const actionLabel = task.taskAction ? taskActionLabel(task.taskAction) : null;

  return (
    <HStack spacing={3} justify="flex-end">
      {isActionable ? (
        <>
          <Button
            variant="outline"
            colorScheme="gray"
            size="sm"
            fontWeight="normal"
            onClick={onSkip}
          >
            Skip
          </Button>
          {actionLabel && (
            <CDS.Button
              intent={CDS.Button.intent.indigo}
              variant={CDS.Button.variant.solid}
              size="sm"
              onClick={onActionClick}
            >
              {actionLabel} ↗
            </CDS.Button>
          )}
          <CDS.Button
            intent={CDS.Button.intent.primary}
            variant={CDS.Button.variant.solid}
            size="sm"
            onClick={onMarkComplete}
          >
            Mark complete
          </CDS.Button>
        </>
      ) : (
        <CDS.Button
          intent={CDS.Button.intent.primary}
          size="sm"
          onClick={task.status === "completed" ? onMarkComplete : onSkip}
        >
          Re-open
        </CDS.Button>
      )}
    </HStack>
  );
}
